import axios from 'axios';

// 创建独立的 axios 实例用于测试，不经过响应拦截器的处理
// baseURL 设置为空，由调用时传入完整路径
const testRequest = axios.create({
  baseURL: '',
  timeout: 60000
});

/**
 * 测试 POST /api/ssz_ai 接口
 * 返回完整的响应对象，包括 status、data 等
 */
export function testSszAiPost(data, baseUrl = '/api') {
  return testRequest({
    url: `${baseUrl}/ssz_ai`,
    method: 'post',
    data
  });
}

/**
 * 测试 GET /api/ssz_ai 接口
 * 返回完整的响应对象，包括 status、data 等
 */
export function testSszAiGet(taskId, baseUrl = '/api') {
  return testRequest({
    url: `${baseUrl}/ssz_ai`,
    method: 'get',
    params: { task_id: taskId }
  });
}

